export function buildShowMap<T>(rows: T[], getKey: (row: T) => string): boolean[] {
  const showMap: boolean[] = [];
  let lastKey: string | null = null;

  rows.forEach((row, index) => {
    const key = getKey(row);
    if (key !== lastKey) {
      showMap[index] = true;
      lastKey = key;
    } else {
      showMap[index] = false;
    }
  });

  return showMap;
}
